import { render, staticRenderFns } from "./vegas.vue?vue&type=template&id=4595e6a7"
import script from "./vegas.vue?vue&type=script&lang=js"
export * from "./vegas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4595e6a7')) {
      api.createRecord('4595e6a7', component.options)
    } else {
      api.reload('4595e6a7', component.options)
    }
    module.hot.accept("./vegas.vue?vue&type=template&id=4595e6a7", function () {
      api.rerender('4595e6a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/vegas.vue"
export default component.exports